/* eslint-disable no-restricted-globals */
import jwt_decode from 'jwt-decode';

const JWT_FORMAT = /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/;

export function isValidJwtFormat(token: unknown): token is string {
    return typeof token === 'string' && token.length > 0 && JWT_FORMAT.test(token);
}

export function safeJwtDecode<T = Record<string, unknown>>(token: string): T | null {
    if (!isValidJwtFormat(token)) {
        return null;
    }

    try {
        return jwt_decode<T>(token);
    } catch {
        return null;
    }
}

export function getStoredAuthToken(stored: { token?: string } | null): string | null {
    if (!stored || !isValidJwtFormat(stored.token)) {
        return null;
    }

    return stored.token;
}

export function isStoredAuthValid(stored: { token?: string } | null): boolean {
    return getStoredAuthToken(stored) !== null;
}

export function isTokenExpired(decoded: { exp?: number }): boolean {
    return typeof decoded.exp === 'number' && Date.now() >= decoded.exp * 1000;
}

export function redirectInvalidAuthToken(): void {
    localStorage.clear();
    location.replace('/error-token');
}
